import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core//Container'

/* export type ComponentProps = {
  style?: React.CSSProperties
} */

const getDate = new Date();
const getYear = getDate.getFullYear();

export const FooterLogin: React.FC<any> = (props) => {
  return (
    <>
      <Box component="footer" style={props.style} className="box__footer">
        <Container maxWidth="lg">
          <div className="footer-sp">
            <div className="footer__details">
              <div>
                <p>
                  HCIDoculink Customer Support:{' '}
                  <a
                    className="support-link"
                    href="mailto:support@hcidoculink.net"
                    target="_blank"
                    rel="noreferrer"
                  >
                    support@hcidoculink.net
                  </a>
                </p>
              </div>
            </div>
            <div>
              <p className="footer__copyright">© {getYear} HCIDoculink, Inc. All rights reserved.</p>
            </div>
          </div>
        </Container>
      </Box>

      <style jsx>{`
    :global(.MuiBox-root.box__footer){
      /* padding: 24px 16px;*/
      padding: 20px 24px 20px 16px;
      z-index: 1;
      position: relative;
      background-color: #F9FAFB;
    }
    .footer__details {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      align-items: center;
    }
    .footer__details div {
      padding: 0 20px;
    }
    .footer__details div p {
      text-align: center;
      font-family: 'Inter', 'Be Vietnam', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #6b7280;
      width: max-content;
    }
    .footer__copyright {
      display: flex;
      margin: auto;
      text-align: center;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      font-family: 'Inter', 'Be Vietnam', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #9ca3af;
    }
    a.support-link {
      font-family: 'Inter', 'Be Vietnam', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-decoration-line: underline;
      color: #0047ba !important;
    }
    .footer-sp {
      display: flex;
      justify-content: space-around;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      align-items: center;
    }

    @media (min-width: 1500px) {
      :global(.MuiBox-root.box__footer){
        margin-top: auto; 
      }
    } 

    @media (max-width: 360px) {
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute;
        background-color: rgb(249, 250, 251);
        width: 100%;
      }   
      .footer-sp {
        display: block !important;
      }   
    }

    @media (max-width: 420px) {
      :global(.MuiBox-root.box__footer){
        padding: 16px 0;
      }
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute
        background-color: rgb(249, 250, 251);
        width: 100%;
      }
      .footer__details div {
        padding: 0 10px;
      }
      .footer-sp {
        display: block !important;
      } 
    }

    @media (max-width: 480px) {
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute;
        background-color: rgb(249, 250, 251);
        width: 100%;
      }

      .footer__details p{
        font-size: 13px !important;
      }
      .footer__copyright{
        font-size: 13px !important;
      }

      a.support-link {
        font-size: 13px !important;
      }
      .footer-sp {
        display: block !important;
      } 
    }

    @media (max-width: 360px) {
      .footer__details p{
        font-size: 12px !important;
      }
      .footer__copyright{
        font-size: 12px !important;
      }

      a.support-link {
        font-size: 12px !important;
      }
      .footer-sp {
        display: block !important;
      } 
    }

    @media (max-width: 720px) {
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute;
        background-color: rgb(249, 250, 251);
        width: 100%;
      }
      .footer-sp {
        display: block !important;
      } 
    }

    @media (max-width: 1024px) {
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute;
        background-color: rgb(249, 250, 251);
        width: 100%;
      }

      .footer-sp {
        display: block !important;
      }
    } 

    @media (max-width: 1280px) {
      .MuiBox-root-5 {
        margin-top: auto;
        padding: 24px 16px;
        z-index: 1;
        position: absolute;
        background-color: rgb(249, 250, 251);
        width: 90%;
      }
      .footer-sp {
        display: block !important;
      }
    }
  `}</style>
    </>
  )
}

export default FooterLogin
